import * as React from 'react'
import { FastField, Field } from 'formik'
import { MuiMobileDatePickerFormik } from '@user/components/Formik/MuiMobileDatePickerFormik'
import { DebouncedTextField } from '@user/components/Formik'
import { FormSection } from '@sales-center/components'
import { TargetPests } from '@user/components/Formik'
import {
  entityNextActionDate,
  addLeadNote,
  entityTargetPests,
} from '@user/components/Settings/EntityFormSettings'
import type { FieldSettingsMap } from '@user/store/entityFormSettings'
import { TextFieldProps } from '@mui/material/TextField'
import Grid from '@mui/material/Grid'

interface Props {
  hideOptional: boolean
  settingsMap: FieldSettingsMap
  customFieldsVisible: boolean
  show: boolean
  textFieldProps?: TextFieldProps
  spacing?: number
}

function OtherInformation(props: Props) {
  const { settingsMap, show, textFieldProps, spacing = 2 } = props

  const [requiredNextActionDate, showNextActionDate] = settingsMap.get(
    entityNextActionDate,
  ) ?? [false, true]
  const [requiredTargetPests, showTargetPests] = settingsMap.get(
    entityTargetPests,
  ) ?? [false, true]
  const [requiredAddNote, showAddNote] = settingsMap.get(addLeadNote) ?? [
    false,
    true,
  ]

  return (
    (show && (showNextActionDate || showTargetPests || showAddNote) && (
      <FormSection label="Other Information" spacing={spacing}>
        {show && showNextActionDate && (
          <Grid item xs={12}>
            <FastField
              name={entityNextActionDate}
              label="Next Action Date"
              component={MuiMobileDatePickerFormik}
              disablePast
              clearable
              fullWidth
              required={requiredNextActionDate}
              {...textFieldProps}
            />
          </Grid>
        )}
        {show && showTargetPests && (
          <Grid item xs={12}>
            <TargetPests
              size={textFieldProps?.size ?? 'small'}
              margin="none"
              name="targetPests"
              required={requiredTargetPests}
              textFieldProps={textFieldProps}
            />
          </Grid>
        )}
        {show && showAddNote && (
          <Grid item xs={12}>
            <Field
              name={addLeadNote}
              component={DebouncedTextField}
              label="Add Note"
              multiline
              required={requiredAddNote}
              {...textFieldProps}
            />
          </Grid>
        )}
      </FormSection>
    )) ||
    null
  )
}

export default React.memo(OtherInformation)
